import { render, staticRenderFns } from "./ModalListWorkCertificate.vue?vue&type=template&id=6a073352&"
import script from "./ModalListWorkCertificate.vue?vue&type=script&lang=js&"
export * from "./ModalListWorkCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports